import React from 'react';
import { MARKET_LIST } from '../constants';
import { navigate } from '@reach/router';
import Select from 'react-select';
import withCommonUtils from './withCommonUtils';
import { withGlobalContext } from '../App';

const MarketSwitcher = props => {
  return (
    <Select
      isSearchable
      options={MARKET_LIST}
      classNamePrefix="formatted_react_select"
      className="market_switcher inline-block ml-2 w-48"
      value={props.getSingleSelectValue(
        MARKET_LIST,
        `${props.country},${props.language}`
      )}
      onChange={({ value }) => {
        const data = value.split(',');
        const savedCountry = data[0];
        const savedLanguage = data[1];
        props.updateMarket({ savedCountry, savedLanguage }, props.onMarketUpdate);

        if (props.basePath) {
          navigate(`${props.basePath}/${savedCountry}/${savedLanguage}`);
        }
      }}
    />
  );
};

export default  withCommonUtils(withGlobalContext(MarketSwitcher));
